import { useCallback, useState } from 'react';
import { ApiError } from '../lib/apiClient';
import { useToast } from '../context/ToastContext';

// Wraps a CSV export call (typically downloadListCsv) with an in-flight
// guard and an error toast — without this, a failed export (e.g. a dropped
// connection mid-fetchAllPages) fails silently with no feedback at all.
export default function useCsvExport(exportFn: () => Promise<void>) {
  const { showError } = useToast();
  const [exporting, setExporting] = useState(false);

  const exportCsv = useCallback(async () => {
    if (exporting) return;
    setExporting(true);
    try {
      await exportFn();
    } catch (err) {
      showError(err instanceof ApiError ? err.message : 'Export failed.');
    } finally {
      setExporting(false);
    }
  }, [exportFn, exporting, showError]);

  return { exporting, exportCsv };
}
